//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchInput from '@/components/search-input';
import SearchSearch from "../../components/search-search";
import receivedArrivalTp from '@/components/page-temporary/received-arrivalTp'
import receivedTp from '@/components/page-temporary/receivedTp'
import {listSort} from "../../utils/commons";
export default {
  name: "list-received",
  components: {SearchSearch,searchInput,receivedArrivalTp,receivedTp},
  data(){
    return{
      tabIndex:1,
      show:true,
      wrapperHeight:0,
      allLoaded:false,
      config:{
        title:'收货管理',
        url:'api/asn-dt/page',
        workflowSearchBean:{},
        tabList:['到货看板','查询收货'],
        fixRules:{},
        inputCondition:{
          placeholder:'物料编号/名称',
          searchCondition:'key',
          rules:[{field: "material.matCode-materialName", option: "LIKE_ANYWHERE"}]
        },
        selectConfig:[
          {
            text: '工厂',
            type: 'search',
            condition: 'plant',
            searchCondition: {label: 'plantName', code: 'plantCode'},
            rules: [{field: "asn.plant.plantCode-asn.plant.plantName", option: "LIKE_ANYWHERE"}],
          },
          {
            text:'送货单状态',
            type:'selector',
            code: "TO_BE_RECEIVED",
            list:[{name:'全部',code:null},{name:'制单中',code:'DRAFT'},{name:'待发货',code:'TO_BE_DELIVERED'},{name:'已发货',code:'TO_BE_RECEIVED'}],
            rules:[{field: "asn.status",option: "EQ"}],
          },
          {
            text: '要货日期',
            type: 'date',
            isOld:true,
            rules:[{field: "deliveryDate",collectIndex: -1,option: "BTD"}],
          }
        ]
      },
      configTodo:{
        title:'收货管理',
        url:'api/stock_table_dt/page',
        tabList:['到货看板','查询收货'],
        property: "stockTable.docNum",
        fixRules:{},
        inputCondition:{
          placeholder:'物料编号/名称',
          searchCondition:'key',
          rules:[{field: "material.matName-material.matCode", option: "LIKE_ANYWHERE"}]
        },
        selectConfig:[
        ]
      },
      statusList:[
        {label:'全部',value:''},
        {label:'草稿',value:'send'},
        {label:'审批中',value:'check'},
        {label:'供应商确认状态',value:'confirm'},
        {label:'已发布',value:'over'},
        {label:'已作废',value:'delete'},
        {label:'已结束',value:'end'}
      ],
      searchData:{},
      list:[],
      showMore:true
    }
  },
  methods:{
    getTabIndex(e){
      this.tabIndex=e;
    },
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    getWorkFlow(){
      this.$get('api/biz-object-parameters/key/contract').then(data=>{
        this.config.workflowSearchBean={
          workflowId:data.workflowType
        };
        this.$refs.header.getlist();
      })
    },
    goAsnDetail(asn){
      this.$router.push("/asn/view/"+asn.id);
    },
    goReceivedDetail(stockTable){
      this.$router.push("/received/view/"+stockTable.id);
    }
  },
  mounted(){
    this.init();
    this.$refs.header.tabIndex = this.$route.query.tabIndex||1;
    this.tabIndex = this.$route.query.tabIndex||1;
    this.getWorkFlow();
  }
}



// WEBPACK FOOTER //
// ./src/page/asn/received-query-list.vue